import { render, staticRenderFns } from "./Ideal.vue?vue&type=template&id=7714603c&scoped=true"
import script from "./Ideal.vue?vue&type=script&lang=js"
export * from "./Ideal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7714603c",
  null
  
)

export default component.exports